var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 461,
    viewBox: "0 0 461 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.251 51C179.108 51 137.301 92.8071 137.301 143.95C137.301 195.093 179.108 236.9 230.251 236.9C281.394 236.9 323.201 195.093 323.201 143.95C323.201 92.8071 281.394 51 230.251 51Z",
    fill: "#6B76C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M389.768 311.179C387.333 305.091 384.086 299.408 380.433 294.132C361.762 266.53 332.944 248.265 300.472 243.8C296.413 243.395 291.949 244.206 288.701 246.641C271.653 259.224 251.359 265.719 230.252 265.719C209.145 265.719 188.85 259.224 171.803 246.641C168.555 244.206 164.09 242.988 160.032 243.8C127.56 248.265 98.3357 266.53 80.0705 294.132C76.4175 299.408 73.17 305.497 70.7352 311.179C69.5178 313.615 69.9233 316.456 71.1407 318.892C74.3882 324.574 78.4468 330.257 82.0998 335.128C87.7821 342.84 93.8708 349.74 100.771 356.234C106.454 361.916 112.948 367.193 119.443 372.47C151.508 396.418 190.068 409 229.846 409C269.624 409 308.184 396.417 340.25 372.47C346.744 367.599 353.238 361.916 358.921 356.234C365.415 349.74 371.91 342.839 377.593 335.128C381.651 329.851 385.305 324.574 388.552 318.892C390.58 316.456 390.986 313.614 389.768 311.179Z",
    fill: "#6B76C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/defaultUser.20125f98050283039f39453ade05ff7c.svg";
export { ForwardRef as ReactComponent };